var _tspan, _tspan2, _tspan3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72mm",
    height: "48mm",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0 24h72",
    fill: "#291212",
    stroke: "#fff",
    strokeDasharray: "1.80000007, 1.80000007",
    strokeDashoffset: 2.7,
    strokeLinejoin: "bevel",
    strokeWidth: 0.3,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4.4409e-16,
    width: 72,
    height: 6,
    fill: "#f00",
    fillOpacity: 0.5,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 72,
    height: 6,
    fill: "#0080ff",
    fillOpacity: 0.5,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.14991,
    y: 0.14991,
    width: 71.7,
    height: 47.7,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.29982,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.85h72",
    fill: "#291212",
    stroke: "#fff",
    strokeDasharray: "1.8, 1.8",
    strokeDashoffset: 2.7,
    strokeLinejoin: "bevel",
    strokeWidth: 0.3,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 42.15h72",
    fill: "#291212",
    stroke: "#fff",
    strokeDasharray: "1.8, 1.8",
    strokeDashoffset: 2.7,
    strokeLinejoin: "bevel",
    strokeWidth: 0.3,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 0.54180199,
    y: 4.3802862,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.54180199,
    y: 4.3802862,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "6\"")), /*#__PURE__*/React.createElement("text", {
    x: 0.54180199,
    y: 15.880286,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.54180199,
    y: 15.880286,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "18\"")), /*#__PURE__*/React.createElement("text", {
    x: 0.54180199,
    y: 34.480286,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.54180199,
    y: 34.480286,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "18\"")), /*#__PURE__*/React.createElement("text", {
    x: 0.54180199,
    y: 46.080284,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.54180199,
    y: 46.080284,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.5278px",
    fontWeight: "bold",
    strokeDasharray: "2.4, 2.4",
    strokeDashoffset: 3.6,
    strokeWidth: 0.4,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "6\"")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.26458 0 0 .26458 -12.462 -2.1078)",
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "13.333px",
    fontWeight: "bold",
    strokeDashoffset: 13.606,
    strokeWidth: 1.1339,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal",
      shapeInside: "url(#rect16761)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 89.400391,
    y: 23.939764
  }, "Player 1  Deployment Zone"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.26458 0 0 .26458 1.9387 16.946)",
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "13.333px",
    fontWeight: "bold",
    strokeDashoffset: 13.606,
    strokeWidth: 1.1339,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal",
      shapeInside: "url(#rect16769)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.400391,
    y: 23.939764
  }, "Center-line"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.26458 0 0 .26458 -12.462 39.746)",
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "13.333px",
    fontWeight: "bold",
    strokeDashoffset: 13.606,
    strokeWidth: 1.1339,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "normal",
      shapeInside: "url(#rect16775)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.400391,
    y: 23.939764
  }, "Player 2  Deployment Zone"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.41e7e8a00549275a807194eda9560d0d.svg";
export { ForwardRef as ReactComponent };